import { render, staticRenderFns } from "./ProjectRankList.vue?vue&type=template&id=b052d5b4&scoped=true"
import script from "./ProjectRankList.vue?vue&type=script&lang=js"
export * from "./ProjectRankList.vue?vue&type=script&lang=js"
import style0 from "./ProjectRankList.vue?vue&type=style&index=0&id=b052d5b4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b052d5b4",
  null
  
)

export default component.exports